<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="400px"
    center
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="保险条款名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入保险条款名称" maxlength="100" />
      </el-form-item>
      
      <el-form-item label="状态" prop="disabled">
        <el-select v-model="form.disabled" placeholder="请选择状态" style="width: 100%">
          <el-option label="启用" :value="false" />
          <el-option label="禁用" :value="true" />
        </el-select>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveInsuranceClause } from '@/api/product'

export default {
  name: 'ClauseEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: null,
        name: '',
        disabled: false
      },
      rules: {
        name: [
          { required: true, message: '请输入保险条款名称', trigger: 'blur' },
          { max: 100, message: '保险条款名称不能超过100个字符', trigger: 'blur' }
        ],
        disabled: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    },
    formData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form = { ...val }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: null,
        name: '',
        disabled: false
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    async handleSave() {
      try {
        await this.$refs.form.validate()
        
        const data = { ...this.form }
        if (!data.id) {
          delete data.id
        }
        
        const res = await saveInsuranceClause(data)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('save')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>